/**
 * @file Reference face related fragments.
 */

import gql from 'graphql-tag';

export const ReferenceFaceDetails = gql`
  fragment ReferenceFaceDetails on ReferenceFace {
    id
    is_active
    face {
      id
      photo {
        id
        thumbnail_urls {
          width
          height
          url
        }
      }
    }
  }
`;
